export interface CustomerApiModel {
  customerData: CustomerData;
}

export interface CustomerData {
  contractAccountsResponse: ContractAccountsResponse;
  contractsResponse: ContractsApiModel;
}

export interface ContractAccountsResponse {
  contractAccounts: ContractAccount[];
}

export interface ContractAccount {
  accountNumber: string;
  firstName: string;
  lastName: string;
  mailingAddress: Address;
  mailingAddressString: string;
  nameId: string;
  pushEnabled: boolean;
}

export interface Address {
  line0: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  line5: string;
  line6: string;
  line7: string;
  line8: string;
  line9: string;
}

export interface ContractsApiModel {
  contracts: ContractModel[];
}

export interface ContractModel {
  accountNumber: string;
  contractNumber: string;
  data: ContractData;
}

export interface ContractData {
  address: string;
  billing: Billing;
  contractStatus: ContractStatus;
  contractType: ContractType;
  fuelType: FuelType;
  processingStatus: ProcessingStatus;
  state: State;
}

export interface Billing {
  frequency: Frequency;
  preferredDayOfMonth: number;
}

export enum Frequency {
  BiMonthly = 'BiMonthly',
  FlexibleMonthly = 'FlexibleMonthly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly'
}

export enum State {
  NSW = 'NSW',
  QLD = 'QLD',
  SA = 'SA',
  VIC = 'VIC',
  WA = 'WA'
}

export enum FuelType {
  Dual = 'Dual',
  Electricity = 'Electricity',
  Gas = 'Gas'
}

export enum ContractStatus {
  Active = 'Active',
  Processing = 'Processing',
  Restricted = 'Restricted'
}

export enum ProcessingStatus {
  CompletedMoveIn = 'CompletedMoveIn',
  InProgress = 'InProgress',
  PendingMoveIn = 'PendingMoveIn',
  PendingNewConnection = 'PendingNewConnection',
  PendingTransferInSitu = 'PendingTransferInSitu',
  PendingTransferMoveIn = 'PendingTransferMoveIn'
}

export enum ContractType {
  Business = 'Business',
  Residential = 'Residential'
}
